import React from 'react';
import { useNews } from 'Components/NewsContext';
import { useTranslation } from "react-i18next";
import { Link } from 'react-router-dom';
import thumbnail from "Assets/Images/thumbnail.png";
import { ReactComponent as ChevronLeft } from "Assets/icons/chevronLeft.svg";
import { ReactComponent as ChevronRight } from "Assets/icons/chevronRight.svg";
import { ReactComponent as CalendarIcon } from "Assets/icons/calendar.svg";
import Loading from 'Components/Loading';
import moment from 'jalali-moment';

const News = () => {
    const { t, i18n } = useTranslation();
    const currentLang = i18n.language;
    const {
        newsData,
        isLoaded,
        imageCache,
        loadingImages,
        getImageSrc,
        clearImageFromCache
    } = useNews();

    const getNewsLink = (newsId) => {
        if (currentLang === 'fa') {
            return `/Media/News/Post/${newsId}`;
        } else {
            return `/Media/News/Post/${newsId}?lang=${currentLang}`;
        }
    };

    if (!isLoaded) {
        return <Loading />;
    }

    return (
        <div className="megaMenuContent">
            <div className="row h-100">
                <p className="fw-bold">{t("latest_published_news")}:</p>
                <div className="d-flex justify-content-between align-items-end gap-4">
                    <div className="news-list col">
                        {newsData.map((news, index) => {
                            const newsLink = getNewsLink(news.id);
                            const imageSrc = getImageSrc(news) || thumbnail;
                            const isLoading = loadingImages[news.id];

                            return (
                                <div className="news-list-item position-relative card-box card-box-sm mb-3" key={news.id || index}>
                                    <div className="row">
                                        <Link to={newsLink} target="_blank" className="news-list-img w-xs-100 d-flex align-items-center justify-content-center">
                                            {isLoading ? (
                                                <img src={thumbnail} className="mx-auto max-width-100" alt="Loading" />
                                            ) : (
                                                <img
                                                    src={imageSrc}
                                                    className="mx-auto max-width-100"
                                                    alt="News Thumbnail"
                                                    onError={(e) => {
                                                        e.target.src = thumbnail;
                                                        if (imageCache[news.id]) {
                                                            clearImageFromCache(news.id);
                                                        }
                                                    }}
                                                />
                                            )}
                                        </Link>
                                        <div className="col">
                                            <div className="media-meta d-flex justify-content-between align-items-center">
                                                <small className="media-date">
                                                    {currentLang === "fa" ? (
                                                        <>
                                                            {moment.from(news.date, 'en').format('jYYYY/jMM/jDD')}
                                                            <CalendarIcon />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <CalendarIcon />
                                                            {news.date}
                                                        </>
                                                    )}
                                                </small>
                                                <div className="box-media-label">{news.newsTypeTitle ?? t("energy_exchange_news")}</div>
                                            </div>
                                            <div className="media-header">
                                                <strong>{news.headLine ?? "..."}</strong>
                                                <h2 className="h4 text-justify mb-0">
                                                    <Link to={newsLink} target="_blank">{news.title ?? "..."}</Link>
                                                </h2>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                    <a href="/Media/News" target="_blank" className="menu-button-width btn rounded-5 bg-primary text-white d-inline-flex justify-content-center align-items-center gap-1 mb-3" >
                        {t('view_news_archive')}
                        <span className="btn p-0 btn-read-more rounded-circle bg-white text-blue d-flex justify-content-center align-items-center">
                            {currentLang === "en" ? <ChevronRight width={15} height={10} /> : <ChevronLeft width={15} height={10} />}
                        </span>
                    </a>
                </div>
            </div>
        </div>
    );
};

export default News;